// extracted by mini-css-extract-plugin
module.exports = {"button":"Tooltip_button__4ts2G"};